<div class="filtros-fecha">
  <div class="filtro-fecha">
    <div class="fecha">
      {{ "Fecha inicio " + fechaInicio.format("DD-MM-YYYY") }}
    </div>
    <img
      src="/assets/iconos/arrow-down-filled-triangle.svg"
      alt=""
      (click)="changeCalendarioSelected(0)"
    />
    <app-calendario-mes
      *ngIf="calendarioSelected === 0"
      style="left: 0"
      (onClickOutside)="changeCalendarioSelected($event)"
      (onFechaActualizada)="actualizarFechaInicio($event)"
      [diaElegido]="fechaInicio"
    ></app-calendario-mes>
  </div>
  <div class="filtro-fecha">
    <div class="fecha">
      {{ "Fecha final " + fechaFinal.format("DD-MM-YYYY") }}
    </div>
    <img
      src="/assets/iconos/arrow-down-filled-triangle.svg"
      alt=""
      (click)="changeCalendarioSelected(1)"
    />
    <app-calendario-mes
      *ngIf="calendarioSelected === 1"
      style="right: 0"
      (onClickOutside)="changeCalendarioSelected($event)"
      (onFechaActualizada)="actualizarFechaFin($event)"
      [diaElegido]="fechaFinal"
    ></app-calendario-mes>
  </div>
</div>
